'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgHistoryCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M3.857 3.615c2.36-2.2 6.077-2.148 8.379.143a5.989 5.989 0 010 8.49c-2.35 2.339-6.179 2.339-8.528 0A5.947 5.947 0 012.01 8.745c-.072-.515.249-.886.668-.891.44-.005.64.29.713.743a4.7 4.7 0 001.291 2.68c1.796 1.788 4.773 1.798 6.58 0 1.805-1.797 1.795-4.76 0-6.548-1.625-1.617-4.217-1.793-6.03-.506l-.172.13c-.106.08-.192.148-.26.202l.565.562a.562.562 0 01-.312.952l-.086.006H2.906a.56.56 0 01-.555-.476l-.006-.082V3.465c0-.47.536-.722.894-.456l.065.056.553.55zM7.11 5.118v2.645l.154.185 1.25 1.346c.2.217.54.23.757.03l.03-.03a.623.623 0 000-.848l-1.095-1.18V5.117a.546.546 0 00-.548-.545.546.546 0 00-.548.545z", fill: "currentColor" }))));
}

module.exports = SvgHistoryCircle;
//# sourceMappingURL=HistoryCircle.js.map
